module.exports = __webpack_public_path__ + "static/media/among_nature.def6d365.svg";